import { render, staticRenderFns } from "./OssConfigManagement.vue?vue&type=template&id=e668badc&scoped=true"
import script from "./OssConfigManagement.vue?vue&type=script&lang=js"
export * from "./OssConfigManagement.vue?vue&type=script&lang=js"
import style0 from "./OssConfigManagement.vue?vue&type=style&index=0&id=e668badc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e668badc",
  null
  
)

export default component.exports